import { useEffect, useState } from 'react';

// Um único carregamento por sessão: o header consulta em toda troca de tela
let chaptersPromise = null;

const loadChapters = () => {
  if (!chaptersPromise) {
    chaptersPromise = fetch('/data/tutorials.json')
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Erro ao carregar tutoriais: ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then((data) => (Array.isArray(data?.chapters) ? data.chapters : []))
      .catch((err) => {
        chaptersPromise = null;
        throw err;
      });
  }
  return chaptersPromise;
};

/**
 * Capítulos de /data/tutorials.json: { chapters: [{ id, number, title, description, lessons: [...] }] }.
 * @returns {{ chapters: Array, loading: Boolean, error: Boolean }}
 */
const useTutorialChapters = () => {
  const [state, setState] = useState({ chapters: [], loading: true, error: false });

  useEffect(() => {
    let active = true;
    loadChapters()
      .then((chapters) => active && setState({ chapters, loading: false, error: false }))
      .catch(() => active && setState({ chapters: [], loading: false, error: true }));
    return () => { active = false; };
  }, []);

  return state;
};

/** Lições ligadas à tela atual (a rota da lição ou uma subrota dela, como a ficha /patients/12). */
export const lessonsForPath = (chapters, pathname) => {
  if (!pathname) return [];
  return chapters.flatMap((chapter) => (chapter.lessons || []).filter(
    (lesson) => lesson.route && (pathname === lesson.route || pathname.startsWith(`${lesson.route}/`))
  ));
};

/** Lições pelos ids, na ordem pedida. */
export const lessonsByIds = (chapters, ids = []) => {
  const all = chapters.flatMap((chapter) => chapter.lessons || []);
  return ids.map((id) => all.find((lesson) => lesson.id === id)).filter(Boolean);
};

export default useTutorialChapters;
